import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { Table } from "reactstrap";
import React, { Component } from 'react';
import { apiFetch, API } from "../../services/api";

// Modal affichant le ROI d'un évènement de captation : personnes captées,
// visites (Athena), transactions attribuées, revenus/commission et ROI vs coût.
export default class EventCaptureRoiModal extends Component {
    state = { roi: null, loading: true, error: null };

    componentDidMount() {
        const slug = this.props.selectedEvent?.slug;
        apiFetch(API.back + '/event-capture-roi?slug=' + encodeURIComponent(slug), { method: 'GET' })
            .then((res) => res.json())
            .then((roi) => this.setState({ roi, loading: false }))
            .catch((err) => {
                console.log(err);
                this.setState({ loading: false, error: "Erreur lors du chargement du ROI" });
            });
    }

    fmtEur = (v) => (Number(v) || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

    render() {
        const { roi, loading, error } = this.state;
        const roiPct = roi && roi.roi !== undefined ? (roi.roi * 100).toFixed(0) + " %" : "—";

        return (
            <Modal show={this.props.isOpen} onHide={this.props.closeModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>ROI — {this.props.selectedEvent?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? <p>Chargement…</p> : null}
                    {error ? <p style={{ color: "#c0392b" }}>{error}</p> : null}
                    {roi ? (
                        <Table responsive>
                            <tbody>
                            <tr><td>Personnes captées</td><td><b>{roi.countOfCaptured}</b></td></tr>
                            <tr><td>Nouveaux comptes</td><td>{roi.countOfNewUsers}</td></tr>
                            <tr><td>Comptes existants</td><td>{roi.countOfExistingUsers}</td></tr>
                            <tr><td>Visites générées</td><td><b>{roi.totalVisits}</b></td></tr>
                            <tr><td>Transactions attribuées</td><td>{roi.countOfTransactions}</td></tr>
                            <tr><td>Chiffre d'affaires généré</td><td>{this.fmtEur(roi.totalRevenue)}</td></tr>
                            <tr><td>Commission générée</td><td><b>{this.fmtEur(roi.totalCommission)}</b></td></tr>
                            <tr><td>Coût de l'évènement</td><td>{this.fmtEur(roi.cost)}</td></tr>
                            <tr><td>ROI (commission vs coût)</td><td><b>{roiPct}</b></td></tr>
                            </tbody>
                        </Table>
                    ) : null}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.closeModal}>Fermer</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
